export enum Sender {
  USER = 'user',
  BOT = 'bot'
}

export enum ResponseType {
  TEXT = 'TEXT',
  CHART = 'CHART'
}

export type SeriesType = 'bar' | 'pie';

export interface SafeBarSeries {
  type: 'bar';
  name?: string;
  data: number[];
}

export interface SafePieData {
  name: string;
  value: number;
}

export interface SafePieSeries {
  type: 'pie';
  name?: string;
  data: SafePieData[];
}

export type SafeSeries = SafeBarSeries | SafePieSeries;

export interface SafeChartOption {
  title?: { text?: string };
  tooltip?: { trigger?: 'item' | 'axis' };
  legend?: { top?: number | string; left?: number | string; orient?: 'horizontal' | 'vertical'; data?: string[] };
  labelLine?: { show: boolean; };
  label?: { show: boolean; };
  grid?: Record<string, unknown>;
  xAxis?: { type?: 'category'; data?: string[]; axisLabel?: Record<string, unknown> };
  yAxis?: { type?: 'value'; min?: number; max?: number };
  series: SafeSeries[];
}

export interface ChatMessage {
  text: string;
  sender: Sender;
  loading?: boolean;
  chartContent?: SafeChartOption;
  responseType?: ResponseType;
  recommendations?: string[];
}

export interface AiResponse {
  answer: string;
  responseType: ResponseType;
  chartContent?: any;
  recommendations?: string[] | null;
}
